import { render, staticRenderFns } from "./AiLibraryTab.vue?vue&type=template&id=119d6188&scoped=true"
import script from "./AiLibraryTab.vue?vue&type=script&lang=js"
export * from "./AiLibraryTab.vue?vue&type=script&lang=js"
import style0 from "./AiLibraryTab.vue?vue&type=style&index=0&id=119d6188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d6188",
  null
  
)

export default component.exports